import { createSlice } from "@reduxjs/toolkit";
import { initInventory } from "./thunks/init";
import * as thunks from "./thunks/thunks";
import { extraReducers } from "./thunks/extraReducers";

export const inventorySlice = createSlice({
  name: "inventory",
  initialState: {
    init: {
      status: "idle",
    },
    filters: {},
    assets: [],
    count: 0,
    parentIds: {},
  },
  reducers: {
    // Keep latest filters in Redux so they survive tab/route remounts
    setFilters: (state, action) => {
      state.filters = action.payload || {};
    },
  },
  extraReducers: {
    ...extraReducers,
  },
});

export const { setFilters } = inventorySlice.actions;

export { initInventory, thunks };

export default inventorySlice.reducer;
